import { defineStore } from 'pinia'
export const useAuthStore = defineStore('auth', {
  state: () => ({
    name: null,
    isAuthenticated: false,
    workSpaces: [],
    selectWpId: null
  }),
  
  actions: {
    setMy(data){
      this.workSpaces = data
      console.log("Полученные WP В хранилище", data)
    },
    SelectWP(id){
      this.workSpaces.filter(el => {return el.id == id})
      if(this.workSpaces.filter(el => {return el.id == id}).length == 1){
        this.selectWpId = id
        return true
      }
      return false
    },
    
    // Выход из системы
    logout() {
      this.name = null
      this.isAuthenticated = false
      this.workSpaces = []
    },
    
    // Проверка сессии при загрузке приложения
    checkAuth() {
      return this.isAuthenticated
    }
  },
  
  getters: {
    getUser: (state) => state.name,
    isLoggedIn: (state) => state.isAuthenticated
  }
})